<div class="flex flex-col gap-4">
  <div (keydown.enter)="submit()" class="flex flex-col gap-4">
    <div class="flex items-end gap-4">
      <div class="flex-1">
        <elcia-text-input [control]="form.controls.name" [label]="'mail-template.name' | translate"/>
      </div>
      <div class="w-48">
        <elcia-local-dropdown [control]="form.controls.localIsoCode"/>
      </div>
    </div>

    <div class="flex-1">
      <elcia-text-input [control]="form.controls.object" [label]="'mail-template.object' | translate"/>
    </div>
  </div>

  <div class="flex flex-col gap-1">
    <label class="text-sm text-primary-500">{{ 'mail-template.body' | translate }}</label>
    <elcia-editor [control]="form.controls.body"/>
  </div>
</div>
